/**
 * Card component for canvas rendering.
 * Container with optional title and subtitle.
 */

import React, { memo } from 'react';
import type { CardProps as CardPropsType } from '../../../types/canvas';

export interface CardComponentProps extends CardPropsType {
  children?: React.ReactNode;
}

function CardComponentBase({ title, subtitle, variant = 'default', children }: CardComponentProps) {
  const variantStyles = {
    default: 'bg-white dark:bg-gray-900',
    outlined: 'bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700',
    elevated: 'bg-white dark:bg-gray-900 shadow-md',
  };

  return (
    <div className={`rounded-lg p-4 ${variantStyles[variant]}`}>
      {(title || subtitle) && (
        <div className="mb-3">
          {title && <h3 className="text-lg font-semibold text-gray-900 dark:text-white">{title}</h3>}
          {subtitle && <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5">{subtitle}</p>}
        </div>
      )}
      {children && <div className="space-y-3">{children}</div>}
    </div>
  );
}

export const CardComponent = memo(CardComponentBase);
